module.exports = "/_next/static/images/macpunks-4-402caa0ecb269860d370c1be14c8f678.png";